<template>
  <div>
    <h1 class="title has-text-centered">
      {{ $t("settlements.faqTitle") }}
    </h1>

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.howSettlementsWorks") }}
    </h2>

    <p>
      {{ $t("settlements.howSettlementsWorksAnswer") }}
    </p>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.howIsTheSettlementMade") }}
    </h2>

    <p v-html="$t('settlements.howIsTheSettlementMadeAnswer')"></p>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.whatAreSettlementsTimes") }}
    </h2>

    <p>
      {{ $t("settlements.whatAreSettlementsTimesAnswer") }}
    </p>
    <br />

    <ul>
      <li>{{ $t("settlements.prepaidTime") }}</li>
      <li>{{ $t("settlements.pixTime") }}</li>
      <li>{{ $t("settlements.debitTime") }}</li>
      <li>{{ $t("settlements.creditTime") }}</li>
    </ul>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.howIsThisTimeCounted") }}
    </h2>

    <p>
      {{ $t("settlements.howIsThisTimeCountedAnswer1") }}
    </p>
    <br />

    <p>
      {{ $t("settlements.howIsThisTimeCountedAnswer2") }}
      <a
        :href="
          locale === 'en'
            ? 'https://s3.us-east-1.amazonaws.com/assets.onii.app/settlements/Settlement%2Bspreadsheet%2B2021%2B2025.xlsx'
            : 'https://s3.us-east-1.amazonaws.com/assets.onii.app/settlements/Planilha%2Bde%2BLiquidac%CC%A7o%CC%83es%2B2021%2Ba%2B2026_202607061153.xlsx'
        "
        target="_blank"
        >{{ $t("settlements.settlementsSpreadsheet") }}</a
      >
      {{ $t("settlements.howIsThisTimeCountedAnswer3") }}
    </p>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.partPrepaidPartCard") }}
    </h2>

    <p>
      {{ $t("settlements.partPrepaidPartCardAnswer") }}
    </p>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.partOrFullCashback") }}
    </h2>

    <p>
      {{ $t("settlements.partOrFullCashbackAnswer") }}
    </p>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.howAreRoyaltiesCalculated") }}
    </h2>

    <p>
      {{ $t("settlements.howAreRoyaltiesCalculatedAnswer") }}
    </p>

    <!-- <ul>
      <li>
        {{ $t("settlements.prepaidDebitCreditRoyalties") }}
      </li>

      <li>
        {{ $t("settlements.prepaidDebitCreditRoyalties") }}
      </li>
    </ul> -->

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.howAreRoyaltiesCharged") }}
    </h2>

    <p>
      {{ $t("settlements.howAreRoyaltiesChargedAnswer") }}
    </p>

    <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.whenDoesThisChargeOccurs") }}
    </h2>

    <p>
      {{ $t("settlements.whenDoesThisChargeOccursAnswer") }}
    </p>

    <!-- <hr />

    <h2 class="subtitle has-text-primary">
      {{ $t("settlements.vouchersNote") }}
    </h2>

    <p>
      {{ $t("settlements.vouchersNoteAnswer1") }}
    </p>
    <br />

    <p>
      {{ $t("settlements.vouchersNoteAnswer2") }}
    </p>
    <br />

    <p>
      {{ $t("settlements.vouchersNoteAnswer3") }}
    </p> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["locale"])
  }
};
</script>

<style scoped>
.title {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.subtitle {
  margin-top: 2rem;
}
hr {
  background-color: #ccc;
}
</style>
